import { VIEW_MOBILE, VIEW_DESKTOP } from '@/config/constants'

function _isDesktop(threshold) {
  const mediaQuery = `(min-width: ${threshold}px)`
  return window.matchMedia(mediaQuery)
}

const Browser = {
  install(Vue, options) {
    const isDesktop = _isDesktop(options.desktopThreshold).matches
    const state = Vue.observable({
      isDesktop,
      isSafari: /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
      viewportLabel: isDesktop ? VIEW_DESKTOP : VIEW_MOBILE,
    })

    Vue.prototype.$browser = state

    const changeState = event => {
      state.isDesktop = event.matches
      state.viewportLabel = state.isDesktop ? VIEW_DESKTOP : VIEW_MOBILE
    }

    if (_isDesktop(options.desktopThreshold).addEventListener) {
      _isDesktop(options.desktopThreshold).addEventListener('change', event => changeState(event))
    } else {
      _isDesktop(options.desktopThreshold).addListener(event => changeState(event))
    }
  },
}

export default Browser
